import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormControl } from '@angular/forms';
import { timestamp } from 'rxjs-compat/operator/timestamp';
import { Utils } from 'src/app/common/utils';
import { VproService } from 'src/app/service/vpro/vpro.service';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-superadmin-medicine-create',
  templateUrl: './superadmin-medicine-create.component.html',
  styleUrls: ['./superadmin-medicine-create.component.css']
})
export class SuperadminMedicineCreateComponent implements OnInit {
  med_type = Utils.MED_TYPE;
  today = Utils.today;
  cate: any;
  subcate: any;
  selected: any;



  constructor(
    private _formBuilder: UntypedFormBuilder,
    private router: Router,
    private service: VproService,
    private spinner: NgxSpinnerService,
  ) { }

  createmedicineform: UntypedFormGroup;

  ngOnInit() {
    this.getMedicinecategory();

    this.createmedicineform = this._formBuilder.group({
      // med_category: [''],
      // med_subcategory: [''],
      med_cate_id: [''],
      med_sub_cate_id: [''],
      med_name: ['', [Validators.required]],
      med_type: ['', [Validators.required]],
      med_strength: [''],
      med_status: [''],
      created_at: [''],
      created_by: [''],

    })
  }

  gotoaddcat() {
    this.router.navigate(['/superadmin/medicine-add-categoy']);
  }

  gotoaddsubcat() {
    this.router.navigate(['/superadmin/medicine-add-subcategory']);
  }
  refresh(): void {
    window.location.reload();
  }
  //get the category
  getMedicinecategory() {

    this.service
      .getMedicinecategory()
      .subscribe(
        (res) => {
          //this.spinner.hide();
          this.cate = res;
          console.log("CATEGORY", this.cate);
        },
        (error) => {
          //this.spinner.hide();
          Utils.showToast("error", "Something went wrong. Please try again.");
        }
      );
  }

  getsubcateid(subcateid) {
    console.log("subcateid", subcateid);
  }

  // save the medicine
  createmedicine() {

    let timestmp = new Date();



    let data = { ...this.createmedicineform.value };
    data.med_cate_id = parseInt(data.med_cate_id);
    data.med_sub_cate_id = parseInt(data.med_sub_cate_id);
    data.med_status = true;
    data.created_at = this.today;
    data.created_by = "Admin";

    this.spinner.show();
    this.service
      .addMedicinemaster({ medicine: [data] })
      .subscribe((result) => {
        Utils.showToast("success", "Medicine added successfully");
        this.spinner.hide();
        this.refresh();
        //this.prescriptionForm.reset();
      });



    let medicine = [{ data }];
    console.log("Medicine", data);

  }

  retriveSubcategory(e) {
    this.selected = e.target.value
    let subcatid = parseInt(this.selected);
    console.log(this.selected);

    this.service
      .retriveMedsubcate({ subcat: subcatid })
      .subscribe((result) => {

        this.subcate = result;
      })
    console.log(this.subcate)

  }


}